import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectFundraisingPage, selectIsPageOwner } from '../../../store/fundraisingPage'
import { selectUser, clearSession } from '../../../store/session'
import { withInjectParams } from '../../utils/InjectParams'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Button from '../../ui/Button'
import ButtonGroup from 'constructicon/button-group'
import Container from 'constructicon/container'
import EditPage from '../../supporters/EditPage'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Head from '../../utils/Head'
import Image from 'constructicon/image'
import Login from '../../supporters/Login'
import Slices from '../../supporters/Slices'

const SupporterPage = ({
  classNames,
  clearSession,
  customSupporterPage,
  fundraisingPage,
  injectParams,
  isPageOwner,
  showLogin,
  styles,
  user
}) => {
  const { banner, meta = {} } = customSupporterPage

  return (
    <div>
      <Head
        title={injectParams(meta.title)}
        description={injectParams(meta.description)}
        keywords={injectParams(meta.keywords)}
        author={injectParams(meta.author)}
        ogType={injectParams(meta.ogType)}
        ogTitle={injectParams(meta.ogTitle)}
        ogDescription={injectParams(meta.ogDescription)}
        ogImage={{ url: fundraisingPage.image }}
      />
      {banner.url && (
        <div className={classNames.banner}>
          <Image
            alt={banner.alt || 'Page banner'}
            src={banner.url}
            styles={styles.image}
          />
        </div>
      )}
      <Container spacing={{ y: 2, x: 1 }}>
        {customSupporterPage.sidebar.length > 0 ? (
          <Grid spacing={1}>
            <GridColumn md={4}>
              <aside className={classNames.sidebar}>
                <Slices
                  customSupporterPage={customSupporterPage}
                  slices={customSupporterPage.sidebar}
                />
              </aside>
            </GridColumn>
            <GridColumn md={8}>
              <main className={classNames.main}>
                <Slices
                  customSupporterPage={customSupporterPage}
                  slices={customSupporterPage.main}
                />
              </main>
            </GridColumn>
          </Grid>
        ) : (
          <main className={classNames.main}>
            <Slices
              customSupporterPage={customSupporterPage}
              slices={customSupporterPage.main}
            />
          </main>
        )}
      </Container>
      {isPageOwner && (
        <div className={classNames.edit}>
          <div className={classNames.intro}>
            <p>Hi {user.firstName},</p>
            <p>Welcome to your fundraising page</p>
          </div>
          <ButtonGroup>
            <EditPage
              fitnessOptions={customSupporterPage.fitness}
              fundraisingPage={fundraisingPage}
              user={user}
            />
            <Button
              background='transparent'
              foreground='dark'
              onClick={() => clearSession()}>
              Log out
            </Button>
          </ButtonGroup>
        </div>
      )}
      {showLogin && (
        <Login />
      )}
    </div>
  )
}

const mapState = (state, props) => ({
  fundraisingPage: selectFundraisingPage(state, props),
  isPageOwner: selectIsPageOwner(state, props),
  user: selectUser(state, props)
})

export default compose(
  withInjectParams,
  withStyles(styles),
  connect(mapState, { clearSession })
)(SupporterPage)
